export default {
  width: {
    themeKey: 'sizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  height: {
    themeKey: 'sizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  minWidth: {
    themeKey: 'sizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  maxWidth: {
    themeKey: 'sizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  minHeight: {
    themeKey: 'sizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  maxHeight: {
    themeKey: 'sizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  margin: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginBottom: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginEnd: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginHorizontal: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginLeft: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginRight: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginStart: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginTop: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  marginVertical: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  padding: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingBottom: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingEnd: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingHorizontal: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingLeft: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingRight: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingStart: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingTop: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  paddingVertical: {
    themeKey: 'spaces',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderBottomEndRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderBottomLeftRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderBottomRightRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderBottomStartRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderTopEndRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderTopLeftRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderTopRightRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderTopStartRadius: {
    themeKey: 'radii',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  shadow: {
    themeKey: 'shadows',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  color: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderTopColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderBottomColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderLeftColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderRightColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  backgroundColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderEndColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderStartColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  placeholderTextColor: {
    themeKey: 'colors',
    responsive: true,
    platform: ['web', 'android', 'ios'],
    prop: 'root'
  },
  zIndex: {
    themeKey: 'zIndices',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  fontSize: {
    themeKey: 'fontSizes',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  fontFamily: {
    themeKey: 'fonts',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  lineHeight: {
    themeKey: 'lineHeights',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  letterSpacing: {
    themeKey: 'letterSpacings',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  fontWeight: {
    themeKey: 'fontWeights',
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  display: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  bottom: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  end: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  left: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  right: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  start: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  top: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  position: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  flexDirection: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  flexWrap: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  justifyContent: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  alignItems: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  alignSelf: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  alignContent: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  overflow: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  flex: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  flexGrow: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  flexShrink: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  flexBasis: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  aspectRatio: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  direction: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  transform: {
    responsive: false,
    platform: ['web', 'android', 'ios']
  },
  shadowColor: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  shadowOffset: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  shadowOpacity: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  shadowRadius: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderStyle: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderBottomWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderEndWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderLeftWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderRightWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderStartWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  borderTopWidth: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  opacity: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  elevation: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  backfaceVisibility: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  fontStyle: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  fontVariant: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textShadowOffset: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textShadowRadius: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textShadowColor: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textAlign: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textAlignVertical: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  includeFontPadding: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textDecorationLine: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textDecorationStyle: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textDecorationColor: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  textTransform: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  writingDirection: {
    responsive: true,
    platform: ['web', 'android', 'ios']
  },
  cursor: {
    responsive: true,
    platform: ['web']
  },
  transition: {
    responsive: true,
    platform: ['web']
  },
  background: {
    responsive: true,
    platform: ['web']
  },
  backgorundImage: {
    responsive: true,
    platform: ['web']
  },
  backdropFilter: {
    responsive: true,
    platform: ['web']
  },
  outlineWidth: {
    responsive: true,
    platform: ['web']
  },
  outlineOffset: {
    responsive: true,
    platform: ['web']
  },
  outlineColor: {
    responsive: true,
    platform: ['web']
  },
  outlineStyle: {
    responsive: true,
    platform: ['web']
  },
  gap: {
    responsive: true,
    platform: ['web']
  },
  rowGap: {
    responsive: true,
    platform: ['web']
  },
  columnGap: {
    responsive: true,
    platform: ['web']
  }
};